import React, { useEffect, useState } from "react";
import { IconKeyboardArrowRightBlue, LogoCurrentBlue } from "assets/svg";
import { axiosInstance } from "config/axiosConfig";
import { API_ENDPOINTS } from "config/apiConfig";
import { CompanyInfoStatusEnum } from "common/enums/CompanyInfoStatus.enum";
import { TransactionStatusEnum } from "common/enums/TransactionStatus.enum";
import { Link } from "react-router-dom";
import { useCommonContext } from "contexts/CommonContext";
import { UTCToJapanTime } from "common/helper/time.helper";

const Dashboard = () => {
  const { setHeaderTitle } = useCommonContext();
  const [numberCompanyPendingReview, setNumberCompanyPendingReview] =
    useState(0);
  const [companyPendingReview, setCompanyPendingReview] = useState<any>({});
  const [numberTransactionCompleted, setNumberTransactionCompleted] =
    useState(0);
  const [numberTransactionProcessing, setNumberTransactionProcessing] =
    useState(0);
  const [conversionInquiry, setConversionInquiry] = useState<any>([]);

  const fetchCompanyCount = () => {
    axiosInstance
      .get(API_ENDPOINTS.COMPANY_INFO_COUNT, {
        params: {
          status: CompanyInfoStatusEnum.PENDING_REVIEW,
        },
      })
      .then((response) => {
        if (response.data.success) {
          setNumberCompanyPendingReview(response.data.data);
        }
      });
  };

  const fetchCompanyPeddingReview = () => {
    axiosInstance
      .get(API_ENDPOINTS.COMPANY_INFO, {
        params: {
          limit: 1,
          status: CompanyInfoStatusEnum.PENDING_REVIEW,
          sort: "id:desc",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setCompanyPendingReview(response.data.data[0]);
        }
      });
  };

  const fetchConversionInquiry = () => {
    axiosInstance
      .get(API_ENDPOINTS.CONVERSATION_INQUIRY, {
        params: {
          limit: 6,
          sort: "id:desc",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setConversionInquiry(response.data.data);
        }
      });
  };

  const fetchTransactionCompletedCount = () => {
    axiosInstance
      .get(API_ENDPOINTS.TRANSACTION_COUNT, {
        params: {
          status: TransactionStatusEnum.COMPLETED,
        },
      })
      .then((response) => {
        if (response.data.success) {
          setNumberTransactionCompleted(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching transaction count:", error);
      });
  };

  const fetchTransactionProcessingCount = () => {
    axiosInstance
      .get(API_ENDPOINTS.TRANSACTION_COUNT, {
        params: {
          status: getTransactionProcessingFilter(),
        },
      })
      .then((response) => {
        if (response.data.success) {
          setNumberTransactionProcessing(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching transaction count:", error);
      });
  };

  const getTransactionProcessingFilter = (): string => {
    const status = [
      TransactionStatusEnum.ACCEPT,
      TransactionStatusEnum.DELIVERED_TO_SHIP,
      TransactionStatusEnum.RECEIVED,
      TransactionStatusEnum.INVOICE_ISSUED,
      TransactionStatusEnum.BUYER_REQUEST_CANCEL,
      TransactionStatusEnum.SELLER_REQUEST_CANCEL,
    ];
    return status.join(",");
  };

  useEffect(() => {
    fetchCompanyCount();
    fetchTransactionCompletedCount();
    fetchTransactionProcessingCount();
    fetchConversionInquiry();
    fetchCompanyPeddingReview();
    setHeaderTitle("ダッシュボード");
  }, []);

  const formatTime = (time: string) => {
    const timeJapan = UTCToJapanTime(time);
    return `${timeJapan.year}/${timeJapan.month}/${timeJapan.day} ${timeJapan.hour}:${timeJapan.minute}`;
  };

  return (
    <div className="self-stretch min-h-[752px] md:min-h-[924px] p-[20px] pb-[100px] md:p-10 bg-white inline-flex flex-col justify-start items-start gap-[20px] md:gap-10 overflow-hidden">
      <div className="md:hidden flex w-full h-[67px] justify-center items-center aspect-[180/67]">
        <LogoCurrentBlue className="w-[180px] h-[73px] shrink-0" />
      </div>
      <div className="self-stretch flex flex-col justify-start items-start gap-[30px] md:gap-10">
        <div className="self-stretch flex flex-col justify-start items-start">
          <div
            data-プロパティ1="base"
            className="self-stretch py-2.5 border-b border-neutral-300 inline-flex justify-start items-center gap-3.5"
          >
            <div className="w-1 self-stretch bg-blue-900 rounded-sm" />
            <div className="flex-1 flex justify-start items-center gap-2.5">
              <div className="flex justify-start items-center gap-[5px]">
                <div className="justify-start text-blue-900 text-[18px] md:text-[22px] font-bold font-['Noto_Sans_JP'] leading-9">
                  審査状況の概要
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-center items-center gap-[5px]">
            <div className="self-stretch flex flex-col justify-start items-start">
              <Link
                to="/admin/review-company"
                className="self-stretch py-2.5 bg-white border-b border-neutral-300 inline-flex justify-center items-center gap-2.5"
              >
                <div className="flex-1 flex flex-col md:flex-row justify-start items-start md:items-center gap-[5px] md:gap-16">
                  <div className="flex-1 justify-start text-black text-sm font-normal font-['Noto_Sans_JP'] leading-snug">
                    審査待ちユーザー：{numberCompanyPendingReview}件
                  </div>
                  <div className="text-right justify-start text-blue-900 text-xs font-normal font-['Noto_Sans_JP'] leading-tight">
                    {companyPendingReview?.created_at
                      ? formatTime(companyPendingReview?.created_at)
                      : ""}
                  </div>
                </div>
                <IconKeyboardArrowRightBlue className="w-[20px] h-[20px] aspect-[1/1]" />
              </Link>
            </div>
          </div>
        </div>
        <div className="self-stretch flex flex-col justify-start items-start">
          <div
            data-プロパティ1="base"
            className="self-stretch py-2.5 border-b border-neutral-300 inline-flex justify-start items-center gap-3.5"
          >
            <div className="w-1 self-stretch bg-blue-900 rounded-sm" />
            <div className="flex-1 flex justify-start items-center gap-2.5">
              <div className="flex justify-start items-center gap-[5px]">
                <div className="justify-start text-blue-900 text-[18px] md:text-[22px] font-bold font-['Noto_Sans_JP'] leading-9">
                  取引ステータス概要
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-center items-center gap-[5px]">
            <div className="self-stretch flex flex-col justify-start items-start">
              <div
                data-プロパティ1="base"
                className="self-stretch py-2.5 bg-white border-b border-neutral-300 inline-flex justify-center items-center gap-2.5"
              >
                <div className="flex-1 flex flex-col md:flex-row justify-start items-start md:items-center gap-[5px] md:gap-16">
                  <div className="flex-1 justify-start text-black text-sm font-normal font-['Noto_Sans_JP'] leading-snug">
                    進行中取引：{numberTransactionProcessing}件
                  </div>
                </div>
              </div>
              <div
                data-プロパティ1="base"
                className="self-stretch py-2.5 bg-white border-b border-neutral-300 inline-flex justify-center items-center gap-2.5"
              >
                <div className="flex-1 flex flex-col md:flex-row justify-start items-start md:items-center gap-[5px] md:gap-16">
                  <div className="flex-1 justify-start text-black text-sm font-normal font-['Noto_Sans_JP'] leading-snug">
                    成立済取引：{numberTransactionCompleted}件
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch flex flex-col justify-start items-start">
          <div
            data-プロパティ1="base"
            className="self-stretch py-2.5 border-b border-neutral-300 inline-flex justify-start items-center gap-3.5"
          >
            <div className="w-1 self-stretch bg-blue-900 rounded-sm" />
            <div className="flex-1 flex justify-start items-center gap-2.5">
              <div className="flex justify-start items-center gap-[5px]">
                <div className="justify-start text-blue-900 text-[18px] md:text-[22px] font-bold font-['Noto_Sans_JP'] leading-9">
                  お知らせ
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-center items-center gap-[5px]">
            {conversionInquiry.map((item: any) => (
              <Link
                to="/admin/conversation-inquiry"
                key={item.id}
                className="self-stretch flex flex-col justify-start items-start"
              >
                <div
                  data-プロパティ1="base"
                  className="self-stretch py-2.5 bg-white border-b border-neutral-300 inline-flex justify-center items-center gap-2.5"
                >
                  <div className="flex-1 flex flex-col md:flex-row justify-start items-start md:items-center gap-[5px] md:gap-16">
                    <div className="flex-1 justify-start text-black text-sm font-normal font-['Noto_Sans_JP'] leading-snug">
                      あなたはユーザーからのリクエスト「{item.subject}
                      」を受け取りました。
                    </div>
                    <div className="text-right justify-start text-blue-900 text-xs font-normal font-['Noto_Sans_JP'] leading-tight">
                      {formatTime(item.created_at)}
                    </div>
                  </div>
                  <IconKeyboardArrowRightBlue className="w-[20px] h-[20px] aspect-[1/1]" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
